<template>
<el-container class="f-h">
    <el-header class="toolbar" style="height: 5.5rem">
        <el-row type="flex" justify="space-between" class="sub-title">
            <div>
                发票:
                <el-button type="primary" size="small" icon="el-icon-document-add" @click="meta.showPut=true" v-if="permission.registration_invoice_create">发票入库</el-button>
            </div>
            <div>
                <el-input v-model="condition.invoicePrefix" placeholder="发票前缀" size="small" class="condition-input" clearable>
                </el-input>
                <el-input v-model="condition.operatorUserName" placeholder="领用人" size="small" class="condition-input" clearable>
                </el-input>
                <el-input v-model="condition.InvoiceNo" placeholder="发票编号" size="small" v-on:keyup.enter.native="queryEntities" class="condition-wide" clearable>
                    <el-button type="info" slot="append" icon="el-icon-search" @click="queryEntities">查询</el-button>
                </el-input>

            </div>
        </el-row>
                <el-tabs v-model="condition.invoiceRecordType" @tab-click="queryRegInvoice">
            <el-tab-pane label="库存记录" name="库存"></el-tab-pane>
            <el-tab-pane label="入库记录" name="入库"></el-tab-pane>
            <el-tab-pane label="领用记录" name="领用"></el-tab-pane>
            <el-tab-pane label="回收记录" name="回收"></el-tab-pane>
            <el-tab-pane label="报损记录" name="报损"></el-tab-pane>
        </el-tabs>
    </el-header>
    <el-main style="padding: 20px 0px 0px 0px">
        <el-table @sort-change="handleSortChange" @filter-change="filterChanged" v-loading="meta.tableloading" :key="Math.random()" height="100%" :data="entities.items" class="main-table">
            <el-table-column v-if="condition.invoiceRecordType == '库存'" label="操作"  align="center" width="100">
                <template slot-scope="scope">
                    <span v-if="permission.registration_invoice_receive">
                        <el-button type="primary" v-if="!scope.row.operatorUserId" plain icon="el-icon-bottom" title="领用" size="mini" @click="showEditor(scope.row,'showReceive')" class="left-pad">领用</el-button>
                    </span>
                    <span v-if="permission.registration_invoice_recyle">
                        <el-button type="warning" v-if="scope.row.operatorUserId" plain :disabled='user.id !== scope.row.operatorUserId' icon="el-icon-top" title="回收" circle size="mini" @click="showEditor(scope.row,'showRecycling')" class="left-pad"></el-button>
                    </span>
                    <span v-if="permission.registration_invoice_scrap">
                        <el-button type="danger" v-if="scope.row.operatorUserId" plain :disabled='user.id !== scope.row.operatorUserId' icon="el-icon-delete" title="报损" circle size="mini" @click="showEditor(scope.row,'showReported')" class="left-pad"></el-button>
                    </span>
                </template>
            </el-table-column>
            <!-- <el-table-column min-width="120" :filters="dictEnum.InvoiceType" :filter-multiple="false" column-key="itemType" sortable="custom" label="记录类型" prop="itemType" align="center">
                <template slot-scope="scope">
                    <el-tag size="small" :type="types(scope.row.itemType)" effect="plain">{{scope.row.itemType}}</el-tag>
                </template>
            </el-table-column> -->

            <el-table-column min-width="130" :filters="meta.deptStaffs" :filter-multiple="false" column-key="operatorUserId" sortable="custom" v-if="condition.invoiceRecordType !== '入库'" label="收费员" prop="operatorUserName" align="center">
                <template slot-scope="{row}">
                    <el-tag v-if="!row.operatorUserId" size="mini" type="warning" effect="plain">收费处</el-tag>
                    <span>{{row.operatorUserName}}</span>
                </template>
            </el-table-column>

            <el-table-column :label="operationDate" prop="operationTime" min-width="120" align="center" sortable="custom" />
            <el-table-column sortable="custom" label="剩余数量" min-width="120" prop="quantity" align="center">
                <template slot-scope="scope">
                    {{scope.row.quantity}}
                </template>
            </el-table-column>
            <el-table-column sortable="custom" label="发票前缀" min-width="120" prop="invoicePrefix" align="center">
                <template slot-scope="scope">
                    {{scope.row.invoicePrefix}}
                </template>
            </el-table-column>
            <el-table-column sortable="custom" label="票据类型" min-width="120" prop="paperType" align="center">
                <template slot-scope="scope">
                    {{scope.row.paperType}}
                </template>
            </el-table-column>
            <el-table-column sortable="custom" label="原始数量" min-width="120" prop="quantity" align="center">
                <template slot-scope="scope">
                    {{scope.row.endNum - scope.row.startNum + 1}}
                </template>
            </el-table-column>
            <el-table-column sortable="custom" label="开始编号" min-width="120" prop="startNum" align="center" />
            <el-table-column sortable="custom" label="结束编号" min-width="120" prop="endNum" align="center" />
            <el-table-column sortable="custom" min-width="120" v-if="condition.invoiceRecordType == '库存'" label="当前编号" prop="currentNum" align="center" />
        </el-table>
    </el-main>
    <pagination :entities='entities' @queryEntities='queryEntities' :condition='condition' />
    <put @queryRegInvoice='queryRegInvoice' :visible.sync="meta.showPut"></put>
    <receive @queryRegInvoice='queryRegInvoice' :entity='entity' :visible.sync="meta.showReceive" />
    <recycling @queryRegInvoice='queryRegInvoice' :entity='entity' :visible.sync="meta.showRecycling"></recycling>
    <reported @queryRegInvoice='queryRegInvoice' :entity='entity' :visible.sync="meta.showReported"></reported>
</el-container>
</template>

<script>
import api from './api';
import { mapGetters } from "vuex";
export default {
    components: {
        put: () => import('./Put'),
        receive: () => import('./receive'),
        recycling: () => import('./recycling'),
        reported: () => import('./reported'),
        pagination: () => import("@/components/_com/pagination")
    },
    data() {
        return {
            entities: {
                items: [],
            },
            condition: {
                invoiceRecordType: "库存",
                sort: "id",
                asc: false,
                pageIndexOnView: 1,
                pageSize: 20,
            },
            entity: {},
            meta: {
                tableloading: false,
                showRecycling: false,
                showReceive: false,
                showPut: false,
                showReported: false,
                deptStaffs: [],
            },
        }
    },
    computed: {
        ...mapGetters(['user', "dictEnum", "permission"]),
        operationDate() {
            return `${this.condition.invoiceRecordType}日期`
        },
    },
    created() {
        let _this = this
        this.$set(this.condition, 'invoiceRecordType', this.dictEnum.InvoiceType[0].code);
        this.queryEntities();
        api.queryStaff({ deptCode: this.user.deptCode, pageSize: 9999, pageIndexOnView: 1 }).then(res => {
            res.items.forEach(i => {
                i.value = i.id
                i.text = i.realName
            })
            _this.meta.deptStaffs = res.items
        })
    },
    methods: {
        handleSortChange({ prop, order }) {
            this.condition.asc = order === "ascending";
            this.condition.sort = prop;
            this.queryEntities();
        },
        filterChanged(options) {
            Object.assign(this.condition, options);
            this.queryEntities();
        },
        types(type) {
            return { '库存': 'info', '入库': 'success', '回收': 'warning', '报损': 'danger' } [type] || '';
        },
        showEditor(row, name) {
            this.entity = JSON.parse(JSON.stringify(row));
            console.log('this.entity=====>', this.entity)
            this.meta[name] = true;
        },
        queryRegInvoice() {
            this.meta.tableloading = true;
            api.queryRegInvoice(this.condition).then(res => {
                this.entities = res;
            }).catch(err => {
                console.log('err: ', err);
            }).finally(() => {
                this.meta.tableloading = false;
            })
        },
        queryEntities() {
            this.queryRegInvoice();
        },
        edit(row) {
            this.entity = JSON.parse(JSON.stringify(row));
            this.$nextTick(() => {
                this.meta.showEditor = true;
            })
        },

    },
}
</script>

<style scoped>

</style>
